export default __webpack_public_path__ + "static/media/20.bf2de5bc.svg";